import { C } from '@ridgewill/brand';

/**
 * The Reports count (support#87), in the nav, the phone menu and the New and
 * Escalated tabs. Jon, 2026-10-24, second pass: a small number in a circle,
 * blue; red, with its background blinking, while a child-safety report is
 * waiting to be opened. Nothing larger, no ring. The blink is `rw-badge-alert`
 * in styles.css; reduced motion leaves it red and still.
 */
export function ReportBadge({ count, urgent }: { count: number; urgent: boolean }) {
  return (
    <span
      className={urgent ? 'rw-badge-alert' : undefined}
      style={{
        marginLeft: 'auto',
        minWidth: 17,
        height: 17,
        padding: '0 4px',
        borderRadius: 9,
        color: '#fff',
        fontSize: '.66rem',
        fontWeight: 650,
        lineHeight: '17px',
        textAlign: 'center',
        fontVariantNumeric: 'tabular-nums',
        background: urgent ? C.danger : C.brand,
      }}
      aria-label={`${count} report${count === 1 ? '' : 's'}${urgent ? ', a child-safety report has not been opened' : ''}`}
    >
      {count}
    </span>
  );
}
